<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <calendar-select
                    v-model="searchParams.date"
                    style="display: block; width: 200px"
                    mode="date"
                  />
                  <!-- @input="" -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo hoạt động hàng ngày</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Ngày đến: ngày khách dự kiến đến</li>
            <li>Ngày đi: Ngày khách dự kiến đi theo đặt phòng</li>
            <li>Số đêm: số đêm ở dự kiến</li>
            <li>Recode: Mã đặt phòng</li>
            <li>Tên khách: Tên khách đặt phòng</li>
            <li>Người lớn: Số lượng người lớn của đặt phòng</li>
            <li>Trẻ em: Số lượng trẻ em của đặt phòng</li>
            <li>Phòng: Tên phòng bao gồm hạng phòng và tên phòng</li>
            <li>Nguồn chi tiết: Nguồn của đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListDailyReport,
  getListDailyReportExcel
} from '@/api/report_service/dailyReport'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import InfoBtn from './components/InfoBtn.vue'
import searchBox from '@/lang/componentsVi/searchBox'

export default {
  components: {
    CalendarSelect,
    SelectWithSearchTable,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        hotelId: []
      },
      defaultSearchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        hotelId: []
      },
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        }
      ],

      columns: [
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          valueGetter: params => {
            if (params.data.arrive_date) {
              return this.$moment(
                params.data.arrive_date,
                'YYYY-MM-DD hh:mm:ss'
              ).format('DD-MM-YYYY hh:mm')
            }
          },
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 160,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'depart_date',
          valueGetter: params => {
            if (params.data.depart_date) {
              return this.$moment(
                params.data.depart_date,
                'YYYY-MM-DD hh:mm:ss'
              ).format('DD-MM-YYYY hh:mm')
            }
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 160,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.numNight'),
          field: 'num_of_night',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 70,
          maxWidth: 80
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          cellStyle: params => {
            if (params.data.rowHeightTotal) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
                // background: 'red'
              }
            }
          },
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            if (params.data.first_name || params.data.last_name) {
              return params.data.first_name + ' ' + params.data.last_name
            }
          },
          tooltipValueGetter: params => {
            if (params.data.first_name || params.data.last_name) {
              return params.data.first_name + ' ' + params.data.last_name
            }
          },
          minWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.adult'),
          field: 'adult_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 100,
          cellStyle: params => {
            if (params.data.rowHeightTotal) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
                // background: 'red'
              }
            }
          }
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.child'),
          field: 'child_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 100,
          cellStyle: params => {
            if (params.data.rowHeightTotal) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
                // background: 'red'
              }
            }
          }
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            return (
              (params?.data?.room_level_nm ? params?.data?.room_level_nm : '') +
              ' ' +
              (params?.data?.room_num ? params?.data?.room_num : ' ')
            )
          },
          tooltipValueGetter: params => {
            return (
              (params?.data?.room_level_nm ? params?.data?.room_level_nm : '') +
              ' ' +
              (params?.data?.room_num ? params?.data?.room_num : ' ')
            )
          },
          // tooltipField: 'name',

          minWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_code',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListSource()
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        getListDailyReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'hoat_dong_hang_ngay_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      try {
        this.loading = true
        const data = await getListDailyReport(this.searchParams)
        this.loading = false
        let arrayArrive = data.map?.arrive.map(element => {
          return { ...element, arrive_date: this.searchParams?.date }
        })
        let arrayDepart = data.map?.depart.map(element => {
          return { ...element, depart_date: this.searchParams?.date }
        })
        let sumAdultArrive = arrayArrive.reduce(
          (sum, { adult_num }) => sum + adult_num,
          0
        )
        let sumChildArrive = arrayArrive.reduce(
          (sum, { child_num }) => sum + child_num,
          0
        )
        let sumAdultDepart = arrayDepart.reduce(
          (sum, { adult_num }) => sum + adult_num,
          0
        )
        let sumChildDepart = arrayDepart.reduce(
          (sum, { child_num }) => sum + child_num,
          0
        )
        // console.log(sumAdult)
        this.rows = [
          {
            name: 'Khách dự kiến đến: ',
            isFullWidthRow: true
          },
          ...arrayArrive,
          {
            recode: `Tổng: ${arrayArrive.length} phòng`,
            adult_num: `Tổng NL: ${sumAdultArrive}`,
            child_num: `Tổng TE: ${sumChildArrive}`,
            // numOfGuest: `Tổng: ${data.data.totalGuest} khách`,
            // revenueAfterDiscount: `Tổng:  ${Number(
            //   data.data.totalRevenue
            // ).toLocaleString('en')}`,
            rowHeightTotal: true
          },

          {
            name: 'Khách dự kiến đi: ',
            isFullWidthRow: true
          },
          ...arrayDepart,
          {
            recode: `Tổng: ${arrayDepart.length} phòng`,
            adult_num: `Tổng NL: ${sumAdultDepart}`,
            child_num: `Tổng TE: ${sumChildDepart}`,
            rowHeightTotal: true
          }
        ]
      } catch {
      } finally {
        this.loading = false
      }
      // this.loading = false
      // data?.map.forEach(element => {
      //   this.rows = [
      //     ...this.rows,
      //     element,
      //     {
      //       name: ['Ghi chú: ', element.note].join(' '),
      //       isFullWidthRow: true
      //     }
      //   ]
      // })
      // this.rows = data.data
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
.ag-cell-wrapper {
  top: 0 !important;
}
</style>
